import format from "date-fns/format";
import { PageContent } from "../../components/Elements/Elements.tsx";
import PageTitle from "../../components/Elements/PageTitle/PageTitle.tsx";
import { IconTable } from "../../components/Icon/Icon.tsx";
import QueryTableWithFilter from "../../components/Table/QueryTableWithFilter.tsx";
import url from "../../module/fetch.tsx";
import { RessourceConsulteeEntity } from "../../Entities/RessourceEntity.tsx";
import useQueryParams from "../../components/Fetch/useQueryParams.tsx";
import FilterLogConnexion, {
  filterValuesToVariable,
  initialFilterValues,
} from "./FilterLogConnexion.tsx";

const ExportLogConnexion = () => {
  const { filterBy = [], sortBy = [] } = useQueryParams();

  return (
    <>
      <PageTitle icon={<IconTable />} title="Export des données" />
      <PageContent>
        <QueryTableWithFilter
          isAutoSubmit={false}
          idName="connexionLogs"
          query={url`/api/exportLogConnexion/logs`}
          filterComponent={
            <FilterLogConnexion filterBy={filterBy} sortBy={sortBy} />
          }
          initialFilterValues={initialFilterValues}
          filterValuesToVariable={filterValuesToVariable}
          columns={[
            {
              Header: "Identifiant",
              accessor: "utilisateurUsername",
              sortField: "utilisateurUsername",
            },
            {
              Header: "Rôles",
              accessor: "roleLibelle",
              sortField: "roleUtilisateur",
            },
            {
              Header: "Connexion",
              accessor: ({ connexionDate }: Date) =>
                format(connexionDate, "dd/MM/yyyy HH:mm"),
              sortField: "connexionDate",
            },
            {
              Header: "Déconnexion",
              accessor: ({ deconnexionDate }: Date) =>
                deconnexionDate
                  ? format(deconnexionDate, "dd/MM/yyyy HH:mm")
                  : null,
              sortField: "deconnexionDate",
            },
            {
              Header: "Durée",
              accessor: "formatedDuree",
              sortField: "duree",
            },
            {
              Header: "Contenus visités",
              accessor: ({
                ressourcesConsultees,
              }: {
                ressourcesConsultees: RessourceConsulteeEntity[];
              }) => {
                return { ressourcesConsultees };
              },
              Cell: (row: {
                value: { ressourcesConsultees: RessourceConsulteeEntity[] };
              }) => {
                return (
                  <div>
                    {row.value.ressourcesConsultees
                      .map((e: RessourceConsulteeEntity) => e.ressourceLibelle)
                      .join(", ")}
                  </div>
                );
              },
            },
          ]}
        />
      </PageContent>
    </>
  );
};

export default ExportLogConnexion;
